import { render, staticRenderFns } from "./ModalSystem.vue?vue&type=template&id=2538fc99&scoped=true&"
import script from "./ModalSystem.vue?vue&type=script&lang=ts&"
export * from "./ModalSystem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2538fc99",
  null
  
)

export default component.exports